import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DependentOpenQuoteModel, DropdownModel } from '../core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DependentService extends ApiService {
  constructor(http: HttpClient) {
    super(http, 'Dependent');
  }

  getDependentsDropdownByCustomerID(customerID: string) : Observable<DropdownModel[]> {
    return this.http.get<DropdownModel[]>(this.route() + `/GetOptionsByCustomerID/${customerID}`);
  }
  
   getDependentsByCustomerID(customerID: string) : Observable<DependentOpenQuoteModel[]> {
    return this.http.get<DependentOpenQuoteModel[]>(this.route() + `/GetDependentsByCustomerID/${customerID}`);
  }
}
